import React from "react";
import { Navigation } from "./navigation";

export const RouteAwareNavigation = ({ userType }) => (
  <div className="route-aware-navigation shadow-sm">
    <Navigation userType={userType} />
  </div>
);
